// src/components/AdminSidebar.jsx
import React, { useState } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import './AdminSider.css'; 

const AdminSidebar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
const toggleSubMenu = (label) => {
  setOpenMenu(openMenu === label ? null : label);
};


  const navItems = [
    { label: "Dashboard", path: "/dashboard" },
  
    {
      label: "Customer",
      path: "/customer",
      children: [
        { label: "Import Customer", path: "/customer/import" },
        { label: "Mandatory Inspection", path: "/customer/inspection" },
        { label: "KYC Validations", path: "/customer/kyc" },
        { label: "Sales Improvement", path: "/customer/sales" },
      ],
    },
  
    { label: "Ecommerce", path: "/ecommerce" },
    { label: "Reports", path: "/reports" },
  ];
  

  const isActive = (path) => location.pathname === path;
  const handleLinkClick = () => setMobileOpen(false);

  // ---------- Auth ----------
  const isLoggedIn = !!localStorage.getItem("token");

  const handleMicrosoftLogin = () => {
    const loginUrl = `https://login.microsoftonline.com/8bef313f-be95-4746-9ef8-d0d45e422151/oauth2/v2.0/authorize?client_id=clientid&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A3001%2Fauth%2Fmicrosoft%2Fcallback&response_mode=query&scope=https%3A%2F%2Fgraph.microsoft.com%2Fuser.read&sso_reload=true`;
    window.location.href = loginUrl;
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("token");
      const tenantId = "8bef313f-be95-4746-9ef8-d0d45e422151";
      const postLogoutRedirectUri = encodeURIComponent(`${window.location.origin}/login`);
      const microsoftLogoutUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${postLogoutRedirectUri}`;
      window.location.href = microsoftLogoutUrl;
    }
  };

  return (
    <>
      {/* ────────────────────── GLOBAL STYLES (unchanged) ────────────────────── */}
      <style jsx>{`
        .header { position:fixed; inset-inline:0; top:0; z-index:50;
          background:#fff; border-bottom:1px solid #e5e7eb; box-shadow:0 1px 3px rgba(0,0,0,.1); }
        .container { max-width:1280px; margin:0 auto; padding:0 1rem; }
        .nav-inner { display:flex; align-items:center; justify-content:space-between; height:64px; }

        .logo { display:flex; align-items:center; gap:.5rem; text-decoration:none;
          color:#111827; font-weight:600; font-size:1.125rem; }

        .desktop-nav { display:none; gap:.5rem; align-items:center; }
        @media (min-width:768px) { .desktop-nav{display:flex;} }

        .nav-link { padding:.5rem 1rem; border-radius:.375rem; font-size:.875rem;
          font-weight:500; color:#374151; text-decoration:none; transition:all .2s; }
        .nav-link:hover { background:#f3f4f6; color:#4f46e5; }
        .nav-link.active { background:#eef2ff; color:#4f46e5; }

        .ms-btn { display:flex; align-items:center; gap:.5rem;
          background:#0078d4; color:white; border:none; padding:.5rem 1rem;
          border-radius:.375rem; font-size:.875rem; font-weight:600;
          cursor:pointer; transition:background .2s; }
        .ms-btn:hover { background:#106ebe; }
        .ms-btn img { width:18px; height:18px; }

        .mobile-toggle { display:block; padding:.5rem; background:none; border:none;
          cursor:pointer; color:#4b5563; }
        @media (min-width:768px) { .mobile-toggle{display:none;} }

        .mobile-menu { position:fixed; inset:0; background:white; z-index:40;
          padding:1rem; display:flex; flex-direction:column; }
        .mobile-header { display:flex; justify-content:space-between; align-items:center;
          margin-bottom:1.5rem; font-weight:600; font-size:1.125rem; }
        .mobile-link { display:block; width:100%; padding:.75rem 1rem; border-radius:.375rem;
          font-size:1rem; font-weight:500; color:#374151; text-decoration:none;
          text-align:left; transition:background .2s; }
        .mobile-link:hover { background:#f3f4f6; }
        .mobile-link.active { background:#eef2ff; color:#4f46e5; }
        .mobile-ms-btn { margin-top:1rem; display:flex; align-items:center;
          justify-content:center; gap:.5rem; background:#0078d4; color:white;
          border:none; padding:.75rem 1rem; border-radius:.375rem;
          font-weight:600; cursor:pointer; }
        .mobile-ms-btn:hover { background:#106ebe; }

        .hamburger,.close { width:24px; height:24px; }

        .page-wrapper { padding-top:64px; min-height:100vh; background:#f9fafb; }

        /* ── Sidebar layout ── */
        .sidebar { position:fixed; inset-block:0; inset-inline-start:0; width:260px;
          background:#fff; border-inline-end:1px solid #e5e7eb;
          box-shadow:2px 0 6px rgba(0,0,0,.07); z-index:40;
          display:flex; flex-direction:column; }
        .sidebar-header { height:64px; padding:0 1rem; display:flex;
          align-items:center; border-bottom:1px solid #e5e7eb; }
        .sidebar-body { flex:1; overflow-y:auto; padding:1rem 0; }
        .sidebar-nav { display:flex; flex-direction:column; gap:.25rem; padding:0 1rem; }
        .sidebar-footer { padding:1rem; border-top:1px solid #e5e7eb; }

        .content-wrapper { margin-inline-start:260px; min-height:100vh;
          background:#f9fafb; padding-top:64px; }
        @media (max-width:767px) {
          .sidebar { transform:translateX(-100%); transition:transform .3s; }
          .sidebar.open { transform:translateX(0); }
          .content-wrapper { margin-inline-start:0; }
        }
      `}</style>

      {/* ────────────────────── TOP BAR (only logo + mobile hamburger) ────────────────────── */}
      <header className="header">
        <div className="container">
          <div className="nav-inner">
            <Link to="/" className="logo">Task Management</Link>

            {/* Mobile sidebar toggle */}
            <button
              onClick={() => setMobileOpen(true)}
              className="mobile-toggle"
              aria-label="Open menu"
            >
              <svg className="hamburger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* ────────────────────── LEFT SIDEBAR ────────────────────── */}
      <aside className={`sidebar ${mobileOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <Link to="/" className="logo">Task Management</Link>
        </div>

        <nav className="sidebar-body">
          <div className="sidebar-nav">
            {isLoggedIn ? (
              <>
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-link ${isActive(item.path) ? "active" : ""}`}
                    onClick={handleLinkClick}
                  >
                    {item.label}
                  </Link>
                ))}

                {/* Logout button (only here) */}
                <button onClick={handleLogout} className="ms-btn" style={{ marginTop: "1rem" }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt="MS" />
                  Logout
                </button>
              </>
            ) : (
              <button onClick={handleMicrosoftLogin} className="ms-btn" style={{ marginTop: "1rem" }}>
                <img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt="MS" />
                Login with Microsoft
              </button>
            )}
          </div>
        </nav>

        {/* Overlay for mobile */}
        {mobileOpen && (
          <div
            className="fixed inset-0 bg-black/30 z-30"
            onClick={() => setMobileOpen(false)}
          />
        )}
      </aside>

      {/* ────────────────────── PAGE CONTENT ────────────────────── */}
      <main className="content-wrapper">
        <Outlet />
      </main>

      {/* ────────────────────── MOBILE FULL‑SCREEN DRAWER ────────────────────── */}
      {mobileOpen && (
        <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
          <div className="mobile-header">
            Task Management
            <button onClick={() => setMobileOpen(false)} className="mobile-toggle" aria-label="Close menu">
              <svg className="close" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {isLoggedIn ? (
            <>
              {navItems.map((item) => (
  <div key={item.path}>
    {/* Main Menu Button */}
    <div
      className={`nav-link ${isActive(item.path) ? "active" : ""}`}
      onClick={() =>
        item.children ? toggleSubMenu(item.label) : handleLinkClick()
      }
      style={{ cursor: "pointer" }}
    >
      {item.label}
    </div>

    {/* Submenu */}
    {item.children && openMenu === item.label && (
      <div className="submenu">
        {item.children.map((sub) => (
          <Link
            key={sub.path}
            to={sub.path}
            className={`submenu-link ${isActive(sub.path) ? "active" : ""}`}
            onClick={handleLinkClick}
          >
            {sub.label}
          </Link>
        ))}
      </div>
    )}
  </div>
))}

              <button onClick={handleLogout} className="mobile-ms-btn">
                <img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt="MS" />
                Logout
              </button>
            </>
          ) : (
            <button onClick={handleMicrosoftLogin} className="mobile-ms-btn">
              <img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt="MS" />
              Login with Microsoft
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default AdminSidebar;